import React, { useEffect, Suspense, Fragment } from "react";
import { Router, Switch, Route } from "react-router-dom";
import PageLoading from "./Components/pageLoading";
import "./style.css";
import { routes } from "./routes";
import { createBrowserHistory } from "history";
import { Toaster } from 'react-hot-toast';
import AuthContext from "src/context/Auth";
import AuthGuard from "src/Components/AuthGuard";
import AuthUi from "src/View/Auth";

import { initGA, trackPageView } from "./analytics";

const history = createBrowserHistory();

export default function App() {
  useEffect(() => {
    initGA(); // Initialize GA once
    trackPageView(window.location.pathname + window.location.search); // Initial page view

    const unlisten = history.listen((location) => {
      trackPageView(location.pathname + location.search);
    });

    return () => {
      unlisten(); // Cleanup listener
    };
  }, []);

  return (
    <div className="App">
      <AuthContext>
        <Router history={history}>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#000',
                color: '#fff',
                cursor: 'pointer',
              }
            }}
          />
          <RenderRoutes data={routes} />
          <AuthUi />
        </Router>
      </AuthContext>
    </div>
  );
}

function RenderRoutes(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <Suspense fallback={<PageLoading />}>
      <Switch>
        {props.data.map((route, i) => {
          const Component = route.component;
          const Guard = route.guard ? AuthGuard : Fragment;
          const Layout = route.layout || Fragment;
          return (
            <Route
              exact={route.exact}
              key={i}
              path={route.path}
              render={(routeProps) => (
                <Guard>
                  <Layout>
                    {route.routes ? (
                      <RenderRoutes data={route.routes} />
                    ) : (
                      <Component {...routeProps} />
                    )}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  );
}
